import React from 'react';
import { Box } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { TopCategories } from '../../../../generated/graphql';
import { Card, CardTitle } from '../../../../ui-kit';
import { DashboardRowWrapper, ItemsPerRow, ResponsiveColumnsContainer } from '../style';
import LinkComponent from '../LinkComponent';
import { useFromToContext } from '../../../shared';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import TopCategoryCard from './TopCategoryCard';


interface CategoriesViewProps extends ItemsPerRow {
    categories: TopCategories[];
    title: string;
    linkUrl?: string;
}

const CategoriesView = ({ categories, title, linkUrl, itemsPerRow = 5 }: CategoriesViewProps) => {
    const { dateFromTo } = useFromToContext();
    const { dateTimeService } = useDateTimeService();
    const history = useHistory();

    let searchParams: string | undefined;
    if (dateFromTo) {
        const from = dateTimeService.getDateTimeFromJsDate(dateFromTo.from).toISODate();
        const to = dateTimeService.getDateTimeFromJsDate(dateFromTo.to).toISODate();
        if (from && to) {
            searchParams = new URLSearchParams({
                from,
                to,
            }).toString();
        }
    }

    const referrer = `${history.location.pathname}${history.location.search}`;

    return (
        <Card fullHeight>
            <DashboardRowWrapper>
                <Box display='flex' alignItems='center'>
                    <CardTitle>{title}</CardTitle>
                    {linkUrl ? <LinkComponent referrer={referrer} search={searchParams} pathname={linkUrl} /> : null}
                </Box>
                <ResponsiveColumnsContainer itemsPerRow={itemsPerRow}>
                    {categories.map(category => (
                        <TopCategoryCard key={category.id} {...category} />
                    ))}
                </ResponsiveColumnsContainer>
            </DashboardRowWrapper>
        </Card>
    );
};

export default CategoriesView;
